export const USER_CACHE_DB_NAME = "polygon_data_user_cache";

export const DB_NAME = "polygonData";

export const DATABASE_VERSION = 1;
